import React, { useState, useEffect, useRef } from "react";
import Header from "../../components/template/estimate/Header";
import "../../assets/css/inventory.css";
import ProgressBar from "../../components/template/ProgressBar";
import { getInventoryData } from "../../adapters/estimate/estimateAdapters";
import { useDispatch, useSelector } from "react-redux";
import {
  loadInventory,
  resetInventory,
  loadFromSession,
} from "../../redux/reducers/inventory/inventoryReducer";
import LoadingInventorySkeleton from "../../components/skeleton/estimate/inventory";
import ItemsCardList from "../../components/inventory/ItemsCardList";
import CategoryList from "../../components/inventory/CategoryList";
import SubCategoryList from "../../components/inventory/SubCategoryList";
import CustomItemsList from "../../components/inventory/CustomItemsList";
import InventoryListModal from "../../components/inventory/Modal/InventoryListModal";
import { List } from "immutable";
import ResetConfirmModal from "../../components/inventory/Modal/ResetConfirmModal";
import { useHistory } from "react-router-dom";
import navigationsLinks from "../../constants/navigation_links";
import { Map } from "immutable";
import { Alert } from "reactstrap";
import { thunkLoadMoveInfoFromSession } from "../../redux/reducers/move_info/moveInfoReducer";
import { thunkLoadPropertyInfoFromSession } from "../../redux/reducers/property_info/propertyInfoReducer";
import { updateStepToActive, thunkClearEstimateData } from "../../redux/reducers/progress/progressReducer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faChevronLeft,
  faChevronRight,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { updateProgressSession } from "../../redux/reducers/progress/progressFn";
import {
  SearchInventory,
  SearchResult,
} from "../../components/inventory/InventorySearch";
import { boxesMainCategoryKey } from "../../constants/inventory";
import { updateOrderData } from "../../adapters/estimate/estimateAdapters";
import { verifyOrderInDB } from "../../functions/helper";

export function getTotalItemsCount(inventoryData) {
  let totalCount = 0;
  inventoryData.get("inventory").forEach((mainCategory, index) => {
    totalCount += getCategoryCount(mainCategory);
  });
  totalCount = totalCount + getCustomItemsCount(inventoryData);
  return totalCount;
}
export function getCategoryCount(mainCategory) {
  let count = 0;
  mainCategory.get("category").forEach((data) => {
    data.get("items").forEach((item) => {
      // item.get("childItems").forEach((childItem) => {
      //   count = count + childItem.get("qty");
      // });
      count = count + item.get("qty");
    });
  });
  return count;
}
export function getCustomItemsCount(inventoryData) {
  const customItemsList = inventoryData.getIn(["customItems", "items"]);
  let count = 0;
  customItemsList.forEach((item) => {
    count = count + parseInt(item.get("item_qty"));
  });
  return count;
}
export function getSubCategoryCount(subCategory) {
  const itemsList = subCategory.get("items");
  let count = 0;
  itemsList.forEach((item, index) => {
    // item.get("childItems").forEach((childItem) => {
    //   count = count + childItem.get("qty");
    // });
    count += item.get("qty");
  });
  return count;
}
export function getBoxesCount(inventoryData) {
  let boxesCount = 0;
  inventoryData.get("inventory").forEach((mainCategory, index) => {
    if (mainCategory.get("name") === boxesMainCategoryKey) {
      const itemsList = mainCategory.getIn(["category", 0, "items"]);
      itemsList.forEach((data) => {
        // let childQty = 0;
        // data.get("childItems").forEach((childItem) => {
        //   childQty += parseInt(childItem.get("qty"));
        // });
        // boxesCount += childQty;
        boxesCount += parseInt(data.get("qty"));
      });
    }
  });
  return boxesCount;
}

export default function Inventory(props) {
  // TODO:
  //1. Sort inventory JSON either on server or from client JavaScript side.

  const history = useHistory();
  const moveInfo = useSelector((state) => state.moveInfo);
  const propertyInfo = useSelector((state) => state.propertyInfo);
  //status state
  const [isLoading, setIsLoading] = useState(false);
  // const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [originalJSON, setOriginalJSON] = useState();

  const inventoryData = useSelector((state) => state.inventoryInfo);
  // inventory list modal
  const [inventoryListModal, setInventoryListModal] = useState(false);
  const toggleInventoryListModal = () =>
    setInventoryListModal(!inventoryListModal);
  //Reset confirm
  const [resetModal, setResetModal] = useState(false);
  //zero inventory alert
  const [zeroInventory, setZeroInventory] = useState(false);
  //menu bar toggle
  const [menuBar, showMenuBar] = useState(false);
  // toggle search
  const [showSearch, setShowSearch] = useState(false);
  //inventory display items update.
  // Signature of selections
  // {
  //   mainCategoryId:"ID of main Category",
  //   subCatgoryId:"ID of sub category",
  // }

  const [currentSelections, setCurrentSelections] = useState(null);
  // const [currentSelections, setCurrentSelections] = useState({
  //   mainCategoryId: "custom_items",
  //   subCategoryId: null,
  // });
  const [search, setSearch] = useState("");
  const [resultList, setResultList] = useState([]);

  const searchItemRef = useRef(null);
  const selectionHeaderRef = useRef(null);

  const updateCurrentSelection = (params) => {
    const { mainCategoryId, subCategoryId } = params;
    const updateSelections = {
      mainCategoryId,
      subCategoryId,
      itemId: params.itemId === undefined ? "" : params.itemId,
    };
    setCurrentSelections(updateSelections);
  };

  const collectInventoryDetails = async (data) => {
    const userSessionData = JSON.parse(
      sessionStorage.getItem("userSessionData")
    );
    const sessionOrderDetails = JSON.parse(
      sessionStorage.getItem("orderDetails")
    );
    const estimateId = sessionOrderDetails.orderId;
    const userId = userSessionData.userId;

    const body = {
      items: data.inventoryData,
      total_items: data.totalItems,
      lead_stage: "inventory_selected",
      version: "v2",
      estimate_id: estimateId,
      user_id: userId,
      update_type: "inventory_info",
    };

    const params = body;
    try {
      const response = await updateOrderData(params);
      console.log(response);
    } catch (e) {
      console.error(e);
    }
  };
  const saveInventory = async (params) => {
    if (Map.isMap(inventoryData)) {
      const count = getTotalItemsCount(inventoryData);
      if (count === 0) {
        setZeroInventory(true);
        window.scrollTo(0, 0);
        return;
      }
      const inventoryInfo = inventoryData.toJS();
      const items = JSON.stringify(inventoryInfo);
      sessionStorage.setItem("inventory_info", items);
      updateProgressSession("step3");
      dispatch(updateStepToActive({ stepToUpdate: "step3" }));
      const isOrderOutdated = await verifyOrderInDB("relocation");
      if (isOrderOutdated === true) {
        dispatch(thunkClearEstimateData());
        history.push("/");
        return;
      }
      collectInventoryDetails({ inventoryData: items, totalItems: count });
      if (params.gotoPage !== undefined) {
        history.push(params.gotoPage);
      } else {
        history.push(navigationsLinks.summary_page);
      }
    }
  };

  function getCurrentSelectedMainCategory() {
    if (currentSelections.mainCategoryId === "custom_items") {
      return "Custom Items";
    }
    const selectedCategory = inventoryData
      .get("inventory")
      .filter((category, index) => {
        return currentSelections.mainCategoryId === category.get("id")
          ? true
          : false;
      });
    if (List.isList(selectedCategory)) {
      return selectedCategory.getIn([0, "displayName"]);
    }
    return "";
  }
  const resetModalOperation = () => {
    setResetModal(false);
    const params = originalJSON;
    dispatch(resetInventory(params));
  };
  useEffect(() => {
    if (
      moveInfo.hasLoadedFromSession === false &&
      propertyInfo.hasLoadedFromSession === false
    ) {
      if (
        sessionStorage.getItem("move_info") !== null &&
        sessionStorage.getItem("property_info") !== null
      ) {
        const moveInfo = sessionStorage.getItem("move_info");
        const propertyInfo = sessionStorage.getItem("property_info");
        dispatch(thunkLoadMoveInfoFromSession({ moveInfo: moveInfo }));
        dispatch(
          thunkLoadPropertyInfoFromSession({ propertyInfo: propertyInfo })
        );
      }
    }
  }, [moveInfo, propertyInfo, dispatch]);
  useEffect(() => {
    // Check first for local session and get it from there and load
    // Else make api and dispatch the state to redux store
    async function loadDataFromAPI() {
      try {
        setIsLoading(true);
        const response = await getInventoryData();
        if (response.data.items) {
          setOriginalJSON(response.data.items);

          if (sessionStorage.getItem("inventory_info") !== null) {
            const inventoryInfo = JSON.parse(
              sessionStorage.getItem("inventory_info")
            );
            dispatch(loadFromSession(inventoryInfo));
            setIsLoading(false);
          } else {
            dispatch(loadInventory(response.data.items));
            setIsLoading(false);
          }
        }
        // console.log(response);
      } catch (e) {
        //Handle error component
        console.log("an error occurred", e);
        setIsLoading(false);
      }
    }
    loadDataFromAPI();
  }, [dispatch]);

  useEffect(() => {
    if (
      inventoryData.getIn(["inventory", 0]) !== undefined &&
      currentSelections === null
    ) {
      const updateSelection = {
        mainCategoryId: inventoryData.getIn(["inventory", 0, "id"]),
        subCategoryId: inventoryData.getIn([
          "inventory",
          0,
          "category",
          0,
          "id",
        ]),
      };
      setCurrentSelections(updateSelection);
    }
  }, [inventoryData, currentSelections]);
  useEffect(() => {
    //search element scrolling into view functionality.
    if (currentSelections !== null) {
      if (
        currentSelections.itemId !== undefined &&
        searchItemRef.current !== null
      ) {
        let elementPosition =
          searchItemRef.current.getBoundingClientRect().top + window.scrollY;
        searchItemRef.current.scrollIntoView();
        window.scrollTo({
          top:
            elementPosition -
            selectionHeaderRef.current.getClientRects()[0].height,
          behavior: "smooth",
        });
        // setInterval(() => {
        //   setCurrentSelections((state) => {
        //     return { ...state, itemId: "" };
        //   });
        // }, 2000);
      }
    }
  }, [currentSelections, searchItemRef]);

  return (
    <React.Fragment>
      <Header currentPage="inventory" referenceToSubmit={saveInventory} />
      <main className="estimate-inventory pb-5">
        <div className="container">
          <section className="progress-bar-section">
            <div className="row align-items-center justify-content-center">
              <div className="col-sm-12 col-md-12 col-lg-9">
                <ProgressBar
                  currentPage="inventory"
                  referenceToSubmit={saveInventory}
                />
              </div>
            </div>
          </section>
        </div>
        {isLoading === true && <LoadingInventorySkeleton />}
        {/* {isLoading === false && currentSelections === null && (
          <LoadingInventorySkeleton />
        )}
        {isLoading === true && currentSelections !== null && (
          <LoadingInventorySkeleton />
        )} */}
        {isLoading === false && currentSelections !== null && (
          <div className="inventory-container container">
            <div className="row">
              <div className="col-sm-12">
                <Alert
                  color="warning"
                  isOpen={zeroInventory}
                  toggle={() => {
                    setZeroInventory(false);
                  }}
                >
                  <b>Inventory Warning! </b> Your Inventory cannot be Zero,
                  Please select atleast one item
                </Alert>
              </div>
            </div>
            {/* START:sm Mobile view */}
            <div className="mobile-responsive-actions">
              <div className="row">
                <div className="col-12">
                  <div className="mb-2 d-flex justify-content-between align-items-center">
                    <h3 className="m-0">
                      Add Inventory{" "}
                      <button
                        onClick={toggleInventoryListModal}
                        className="badge badge-pill btn ml-1 d-inline-flex align-items-center justify-content-center total-items-modal-count"
                      >
                        {getTotalItemsCount(inventoryData)}
                      </button>{" "}
                    </h3>

                    <div className="action-btn-container">
                      {/* <button className="search-icon btn btn-dark mr-1"> */}
                      <span
                        style={{ fontSize: "1.2rem", marginRight: "0.8rem" }}
                      >
                        <FontAwesomeIcon
                          icon={faSearch}
                          onClick={() => {
                            if (showSearch === true) {
                              setShowSearch(!showSearch);
                              setSearch("");
                              setCurrentSelections((state) => {
                                return { ...state, itemId: "" };
                              });
                            } else {
                              setShowSearch(!showSearch);
                            }
                          }}
                        />
                      </span>
                      {/* </button> */}
                      <button
                        className="btn btn-primary btn-sm mr-1"
                        onClick={() => {
                          setResetModal(true);
                        }}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                  <div className="actions-list">
                    {showSearch === true && (
                      <SearchInventory
                        update={{
                          search,
                          setSearch,
                          resultList,
                          setResultList,
                        }}
                        clearToggle={() =>
                          setCurrentSelections((state) => {
                            return { ...state, itemId: "" };
                          })
                        }
                      />
                    )}
                  </div>
                  <SearchResult
                    update={{
                      search,
                      setSearch,
                      resultList,
                      setResultList,
                    }}
                    updateSearchSelect={(params) => {
                      updateCurrentSelection(params);
                    }}
                    toggleCustomItems={() => {
                      setCurrentSelections({
                        mainCategoryId: "custom_items",
                        subCategoryId: "",
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            {/* END:sm Mobile view */}
            <div className="row">
              <div
                className={`col-sm-12 col-md-3 col-lg-3 col-xl-2 category-nav ${menuBar === true ? "category-nav-visible" : ""
                  }`}
              >
                <div className="inventory-type-list">
                  <div className="toggle-menu">
                    <div>
                      <button
                        className="btn btn-dark"
                        onClick={() => {
                          showMenuBar(false);
                        }}
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                  <div className="mb-4 d-flex justify-content-between align-items-center inventory-cta">
                    <h3 className="m-0">Add Inventory </h3>
                    <button
                      onClick={toggleInventoryListModal}
                      className="badge badge-pill btn ml-1 d-flex align-items-center justify-content-center total-items-modal-count"
                    >
                      {getTotalItemsCount(inventoryData)}
                    </button>
                  </div>
                  <CategoryList
                    currentSelections={currentSelections}
                    updateCurrentSelection={updateCurrentSelection}
                  />
                </div>
              </div>

              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-10  border-0">
                <section className="inventory-section">
                  <div className="category-selection" ref={selectionHeaderRef}>
                    <div className="inventory-actions">
                      <h3 className="category-title">
                        <button
                          className="category-nav-toggle btn btn-active mr-2"
                          onClick={() => {
                            showMenuBar(!menuBar);
                          }}
                        >
                          {" "}
                          <FontAwesomeIcon icon={faBars} />{" "}
                        </button>
                        {getCurrentSelectedMainCategory()}
                      </h3>
                      <div className="inventory-actions-list">
                        <SearchInventory
                          update={{
                            search,
                            setSearch,
                            resultList,
                            setResultList,
                          }}
                          clearToggle={() =>
                            setCurrentSelections((state) => {
                              return { ...state, itemId: "" };
                            })
                          }
                        />

                        {/* <div className="search-inventory-container">
                          <button
                            className="btn btn-sm btn-dark"
                            onClick={() => {
                              setShowSearch(!showSearch);
                              setCurrentSelections((state) => {
                                return { ...state, itemId: "" };
                              });
                            }}
                          >
                            {" "}
                            <FontAwesomeIcon icon={faSearch} />{" "}
                          </button>
                        </div> */}
                        <div className="action-btn-container">
                          <button
                            className="btn btn-primary btn-sm"
                            id="propmt-selection-reset"
                            onClick={() => {
                              setResetModal(true);
                            }}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="result-container">
                      <SearchResult
                        update={{
                          search,
                          setSearch,
                          resultList,
                          setResultList,
                        }}
                        updateSearchSelect={(params) => {
                          updateCurrentSelection(params);
                        }}
                        toggleCustomItems={() => {
                          setCurrentSelections({
                            mainCategoryId: "custom_items",
                            subCategoryId: "",
                          });
                        }}
                      />
                    </div>
                    {currentSelections.mainCategoryId !== "custom_items" && (
                      <SubCategoryList
                        currentSelections={currentSelections}
                        updateCurrentSelection={updateCurrentSelection}
                      />
                    )}
                  </div>
                  <div className="inventory-items">
                    <div className="row">
                      <ItemsCardList
                        currentSelections={currentSelections}
                        searchItemRef={searchItemRef}
                      />
                    </div>
                  </div>
                </section>

                {currentSelections.mainCategoryId === "custom_items" && (
                  <CustomItemsList />
                )}
                <div className="navigate-inventory">
                  <div className="text-center mt-5">
                    <button
                      className="btn btn-sm btn-dark bottom-nav mr-2"
                      onClick={() => {
                        saveInventory({
                          gotoPage: navigationsLinks.property_info_page,
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faChevronLeft} /> Floor Info{" "}
                    </button>
                    <button className="btn btn-sm" onClick={saveInventory}>
                      Summary <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                  </div>

                  <p className="read-me mt-4 mx-auto">
                    {" "}
                    Please describe the items, so that we can understand them
                    better. We would be able to provide you a more accurate
                    quote once you provide us this.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        <InventoryListModal
          modal={inventoryListModal}
          toggle={toggleInventoryListModal}
        />
        <ResetConfirmModal
          modal={resetModal}
          toggle={() => setResetModal(false)}
          resetModalOperation={resetModalOperation}
        />
      </main>
    </React.Fragment>
  );
}
